module.exports = __webpack_public_path__ + "img/114.5.4e1cb7c3.png";